import { useTranslation } from 'react-i18next';
import React from 'react';
import { SVGAssets } from '@business/assets/vectors';
import { Button } from '@business/workflows/ComponentUI';
import { dotenv } from '@utils/constants/env';

export const BackToWebsite: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-end text-sm mb-4">
      <SVGAssets.ArrowLeftIcon className="w-5 text-[var(--na-primary-color)]" />
      <Button
        btnStyle="link"
        type="button"
        href={dotenv.MARKETING_SITE_URL}
        rel="noopener noreferrer"
        className="text-[var(--na-primary-color)] underline font-semibold">
        {t('backToWebsite')}
      </Button>
    </div>
  );
};
